import { createContext, useContext, ReactNode } from 'react';

interface FeatureFlags {
  marketplaceEnabled?: boolean;
}

interface FeatureFlagsContextType {
  flags: FeatureFlags;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextType | undefined>(
  undefined
);

interface FeatureFlagsProviderProps {
  children: ReactNode;
  flags: FeatureFlags;
}

export const FeatureFlagsProvider = ({
  children,
  flags,
}: FeatureFlagsProviderProps) => {
  return (
    <FeatureFlagsContext.Provider value={{ flags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlags = () => {
  const context = useContext(FeatureFlagsContext);
  if (context === undefined) {
    throw new Error(
      'useFeatureFlags must be used within a FeatureFlagsProvider'
    );
  }
  return context;
};
